import { all } from "redux-saga/effects";
import alertsWatcher from "./alerts";
import blogsWatcher from "./blogs";
import categoriesWatcher from "./categories";
import couponsWatcher from "./coupons";
import faqsWatcher from "./faqs";
import headNurseWatcher from "./headNurse";
import itSupportWatcher from "./itSupport";
import nursesWatcher from "./nurses";
import orderWatcher from "./order";
import productsWatcher from "./products";
import resourcesWatcher from "./resources";
import seniorWatcher from "./senior";
import seniorHomesWatcher from "./senior_homes";
import servicesWatcher from "./services";
import shippingWatcher from "./shipping";
import subscriptionWatcher from "./subscription";
import userWatcher from "./user";
import videoMeetWatcher from "./videoMeet";
import regionWatcher from "./region";

export default function* rootSaga() {
    yield all([
        ...userWatcher,
        ...servicesWatcher,
        ...alertsWatcher,
        ...couponsWatcher,
        ...blogsWatcher,
        ...resourcesWatcher,
        ...orderWatcher,
        ...seniorHomesWatcher,
        ...nursesWatcher,
        ...itSupportWatcher,
        ...videoMeetWatcher,
        ...productsWatcher,
        ...categoriesWatcher,
        ...shippingWatcher,
        ...faqsWatcher,
        ...seniorWatcher,
        ...headNurseWatcher,
        ...subscriptionWatcher,
        ...regionWatcher,
    ]);
}
